import React from "react";
import PathfindingVisualizer from "./components/PathfindingVisualizer";

function App() {
  return (
    <div>
      <PathfindingVisualizer />
    </div>
  );
}

export default App;
